export const GET_CURRENT_MISSION = 'GET_CURRENT_MISSION'
export const DELETE_MISSION = 'DELETE_MISSION'
export const OVERVIEW_TRANSLATE = 'OVERVIEW_TRANSLATE'
export const REQUIREMENTS_TRANSLATE = 'REQUIREMENTS_TRANSLATE'
export const OPTIONS_TRANSLATE = 'OPTIONS_TRANSLATE'
export const PACKAGE_TRANSLATE = 'PACKAGE_TRANSLATE'
